import React from 'react';
import '../Header.css';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import LanguageIcon from '@material-ui/icons/Language';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Avatar, Button } from '@material-ui/core';
import { useHistory } from "react-router-dom";
import PlacesAutocomplete from "react-places-autocomplete";

function Header() {
    const history = useHistory();

    return (
        <div className="header">
            {/****** LOGO WITH NAVIGATION ******/}
            <img
                onClick={() => history.push('/')}
                className="header__logo"
                src="https://cdn.logo.com/hotlink-ok/logo-social-sq.png"
                alt="logo"
                />

            {/******** SEARCH BAR ********/}
            <div className="header__center">
                {/* <PlacesAutocomplete>
                    {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => 
                    <div>
                        <input {...getInputProps({placeholder: "Where are you going?"})} />
                        <div>
                            { loading ? <div>Loading...</div> : null }
                            {suggestions.map((suggestion) => {
                                return (
                                    <div>
                                        {suggestion.description}
                                    </div>
                                )
                            })}
                        </div>
                    </div>}
                </PlacesAutocomplete> */}
                <input type="text" placeholder="Where are you going?" />
                <LocationOnIcon className="location__icon" />
            </div>

            {/******** NAVIGATION ICONS ********/}
            <div className="header__right">
                <Button variant="outlined">Become a Host</Button>
                <LanguageIcon />
                <ExpandMoreIcon />
                <Avatar />
            </div>
        </div>
    )
}

export default Header;